import { useBackingAssets } from '@ethena/shared-ui/src/hooks/useBackingAssets'
import { useReserveFund } from '@ethena/shared-ui/src/hooks/useReserveFund'
import { useTokenSupply } from '@ethena/shared-ui/src/hooks/useTokenSupply'
import { formatLastUpdated } from '@ethena/shared-ui/src/utils/formatLastUpdated'

export const useTransparencyData = () => {
  const { isLoading: isLoadingReserveFund, totalReserveFundInUsd = 0 } = useReserveFund()

  const { isLoading: isLoadingBackingAssets, totalBackingAssetsInUsd = 0 } = useBackingAssets()
  const { lastUpdated: usdeSupplyLastUpdated, tokenSupply } = useTokenSupply('USDe')

  const backingAssetsAndReserveFund =
    isLoadingBackingAssets || isLoadingReserveFund ? undefined : totalBackingAssetsInUsd + totalReserveFundInUsd

  const protocolBackingRatio =
    backingAssetsAndReserveFund && tokenSupply
      ? `${((backingAssetsAndReserveFund / tokenSupply) * 100).toFixed(2)}%`
      : undefined

  return {
    backingLastUpdated: formatLastUpdated(usdeSupplyLastUpdated),
    protocolBackingRatio,
  }
}
